


































import { Vue, Component, Prop } from 'vue-property-decorator';

import { WidgetThemesDictionary } from '@/models/Widget/themes';

import {
  IWidgetSettingsFormData,
  WidgetNameIcon
} from '@/models/Widget/settings';

import Typography from '@/components/atoms/Typography/Typography.vue';
import WidgetIcon from '@/componentsV2/organisms/MockupWidgetPreview/WidgetIcon.vue';

@Component({
  components: {
    Typography,
    WidgetIcon
  }
})
export default class WidgetIconSelect extends Vue {
  @Prop() widgetConfigProps!: IWidgetSettingsFormData;
  @Prop({ default: 'coin' }) value!: WidgetNameIcon;
  @Prop({ default: false }) showActiveLabel?: boolean;
  @Prop({ default: false }) isInternalPage?: boolean;
  @Prop({ default: false }) disabled?: boolean;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get icons() {
    return [
      {
        name: 'coin',
        label: 'Coin'
      },
      {
        name: 'wallet',
        label: 'Wallet'
      },
      {
        name: 'gift',
        label: 'Gift'
      },
      {
        name: 'trophy',
        label: 'Trophy'
      }
    ];
  }

  get getTheme() {
    return Object.entries(WidgetThemesDictionary).filter(
      ([colorName]) => colorName === this.widgetConfigProps.widgetStyle.color
    )[0][1].primaryColor;
  }

  isActive(value: string) {
    return this.value === value;
  }

  selectIcon(icon: WidgetNameIcon) {
    this.$emit('input', icon);
  }
}
